export function formatNumber({
  locale = 'en-US',
  currency = 'USD',
  style = 'currency',
  minimumFractionDigits = 2,
  number,
}: {
  locale?: string;
  currency?: string;
  style?: string;
  number: number;
  minimumFractionDigits?: number;
}) {
  const rawNumber = !isNaN(number) ? number : 0;

  return new Intl.NumberFormat(locale, {
    style,
    currency,
    minimumFractionDigits,
  }).format(rawNumber);
}
